import { api } from '@/lib/api';
import type { IApiResponse, IRawDimIssue } from '@skystone/shared';

export const rawDimIssueApi = {
  getAll: async (): Promise<IRawDimIssue[]> => {
    const result = await api.get<IApiResponse<IRawDimIssue[]>>('/raw-dim-issues');
    return result.data;
  },
};
